import { useToastedMutation } from '../../../ReactQuery';
import { post } from '../../../redux/api';
import type { SocialCompleteRequest, SocialCompleteResponse } from '../../../../shared/types/routes/auth/v2';

/**
 * Finalizes a deferred multi-org social login via `POST /api/auth/login/social/complete`: the user picked which org to
 * complete the OAuth sign-in into. The backend reads the stashed OAuth handle from the session, so the body carries
 * only the chosen org. No toast is wired here — the picker renders expected failures inline and reserves toasts for
 * unexpected errors.
 */
export function useSocialComplete() {
  return useToastedMutation({
    mutationFn: async (body: SocialCompleteRequest) =>
      (await post<SocialCompleteRequest, SocialCompleteResponse>('/api/auth/login/social/complete', body)).data,
  });
}
